import { IAction } from './action';

export class SetIsDisabled implements IAction {
    constructor(public isDisabled: boolean) {}
}
